import { useQueryClient } from "@tanstack/react-query"
import { SendHorizonal } from "lucide-react"
import { useState } from "react"
import { useTranslation } from "@/language"
import { broadcastNotification } from "../services/notification.service"

export function NotificationInput() {
  const { t } = useTranslation("common")
  const [message, setMessage] = useState("")
  const [isLoading, setIsLoading] = useState(false)
  const queryClient = useQueryClient()

  const handleSubmit = async () => {
    if (!message.trim() || isLoading) return

    setIsLoading(true)
    try {
      await broadcastNotification(message.trim())
      setMessage("")
      queryClient.invalidateQueries({ queryKey: ["notifications", "all"] })
      queryClient.invalidateQueries({ queryKey: ["notifications", "you"] })
    } catch (error) {
      console.error("Failed to broadcast notification:", error)
    } finally {
      setIsLoading(false)
    }
  }

  const handleKeyDown = (e: React.KeyboardEvent) => {
    if (e.key === "Enter" && !e.shiftKey) {
      e.preventDefault()
      handleSubmit()
    }
  }

  return (
    <div className="relative">
      <input
        type="text"
        placeholder={t("notifications.inputPlaceholder")}
        value={message}
        onChange={e => setMessage(e.target.value)}
        onKeyDown={handleKeyDown}
        disabled={isLoading}
        className="
          w-full h-[65px] px-3.75 py-5
          rounded-[15px]
          text-[14px] text-primary placeholder:text-stone/50 border
          border-[#F2F0EB26] bg-[#F2F0EB0D] focus:outline-none
          disabled:opacity-50
        "
      />

      <button
        type="button"
        onClick={handleSubmit}
        disabled={!message.trim() || isLoading}
        className="absolute top-5 right-4 cursor-pointer disabled:opacity-50"
      >
        <SendHorizonal className="size-6" />
      </button>
    </div>
  )
}
